import { useContent } from '@/content'
import { Surface } from '@/components/ui'
import styles from './SkillMatrix.module.css'

/** The full technical skill set, grouped by discipline. */
export const SkillMatrix = () => {
  const { skillGroups } = useContent()

  return (
  <Surface pad={20} radius="shell" className={styles.panel}>
    <h2 className="t-24">Technical skills</h2>
    <ul className={styles.grid}>
      {skillGroups.map((group) => (
        <Surface as="li" key={group.id} interactive className={styles.group}>
          <h3 className={`t-12 ${styles.name}`}>{group.name}</h3>
          <ul className={styles.items}>
            {group.items.map((item) => (
              <li key={item} className={styles.chip}>
                {item}
              </li>
            ))}
          </ul>
        </Surface>
      ))}
    </ul>
  </Surface>
  )
}
